import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Layout from 'components/Layout';
import SideBar from 'components/SideBar';
import BandMembersList from 'components/BandMembersList';

import Title from 'components/ui/Title';
import ArrowLink from 'components/ui/ArrowLink';

import photo from 'assets/photos/band1.jpg';

import {
  Wrapper,
  Section,
  Figure,
  Image
} from './MainPage.styles';

const MainPage = () => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Layout sidebar={(<SideBar />)}>
      <Wrapper>
        <Section>
          <Title size="big" color="secondary">
            {intl.formatMessage({ id: 'homePage.noFans.title' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </Title>
          <Figure>
            <Image src={photo} alt="" />
          </Figure>
          <p>
            {intl.formatMessage({ id: 'homePage.noFans.description1' }, {
              bandName: <b>{locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP}</b>
            })}
          </p>
          <p>
            {intl.formatMessage({ id: 'homePage.noFans.description2' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </p>
          <BandMembersList />
          <p>
            {intl.formatMessage({ id: 'homePage.noFans.description3' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </p>
          <ArrowLink to="/about" size="small" color="black">
            {intl.formatMessage({ id: 'homePage.noFans.link' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </ArrowLink>
        </Section>
        <Section>
          <Title size="big" color="primary">
            {intl.formatMessage({ id: 'homePage.fans.title' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </Title>
          <p>
            {intl.formatMessage({ id: 'homePage.fans.description1' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </p>
          <p>
            {intl.formatMessage({ id: 'homePage.fans.description2' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </p>
          <p>
            {intl.formatMessage({ id: 'homePage.fans.description3' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </p>
          <p>
            {intl.formatMessage({ id: 'homePage.fans.description4' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </p>
          <Title size="small" color="black">
            {intl.formatMessage({ id: 'homePage.fans.description5' }, {
              bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
            })}
          </Title>
        </Section>
      </Wrapper>
    </Layout>
  );
};

export default MainPage;
